// extracted by mini-css-extract-plugin
export default {"project-fields":"styles_project-fields__xR7Po","project-fields-wrap":"styles_project-fields-wrap__D9l36"};